import React,{ useState } from 'react';
import styles from './AlertModal.module.css';


export const AlertModal = ({ message, onClose, color = 'red' }) => {
  const getColors = (color) => {
    switch (color) {
      case 'green':
      
        return {
          borderColor: '#28a745',
          textColor: '#218838',
          buttonColor: '#28a745',
          buttonHover: '#218838',
        };
      case 'red':
      default:
        return {
          borderColor: '#f50601',
          textColor: '#ee0000',
          buttonColor: '#f10501',
          buttonHover: '#ff0404',
        };
    }
  };

  const { borderColor, textColor, buttonColor, buttonHover } = getColors(color);

  return (
    <div className={styles.backdrop}>
      <div
        className={styles.modal}
        style={{ borderLeft: `6px solid ${borderColor}` }}
      >
        <p style={{ color: textColor }}>{message}</p>
        <button
          onClick={onClose}
          style={{
            backgroundColor: buttonColor,
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = buttonHover)}
          onMouseOut={(e) => (e.target.style.backgroundColor = buttonColor)}
        >
          OK
        </button>
      </div>
    </div>
  );
};


// export const AlertConditionModal = ({message, onTrue, OnFalse}) =>(
//   <div className={styles.backdrop}>
//     <div className={styles.modal}>
//       <p>{message}</p>
//       <button onClick={onTrue}>Yes</button>
//       <button onClick={OnFalse}>No</button>
//     </div>
//   </div>
// )

// useConfirmation.js


